import AddressLineField from 'components/AddressModal/components/AddressLineField/styled';

export default AddressLineField;
